/* eslint-disable camelcase */

/**
 * NOTE: This is an auto-generated file
 */

import AirPlay from './assets/customer/default/controls/AirPlay.svg';
import AirPlayOff from './assets/customer/default/controls/AirPlayOff.svg';
import AirPlayOn from './assets/customer/default/controls/AirPlayOn.svg';
import ArrowDown from './assets/customer/default/controls/ArrowDown.svg';
import ArrowLeftWithBase from './assets/customer/default/controls/ArrowLeftWithBase.svg';
import ArrowUp from './assets/customer/default/controls/ArrowUp.svg';
import AudioDescription from './assets/customer/default/controls/AudioDescription.svg';
import BackSpace from './assets/customer/default/controls/BackSpace.svg';
import BackToLive from './assets/customer/default/controls/BackToLive.svg';
import BackToLiveHBBTV from './assets/customer/default/controls/BackToLiveHBBTV.svg';
import Brightness from './assets/customer/default/controls/Brightness.svg';
import Brightness1 from './assets/customer/default/controls/Brightness1.svg';
import Brightness2 from './assets/customer/default/controls/Brightness2.svg';
import Brightness3 from './assets/customer/default/controls/Brightness3.svg';
import Brightness4 from './assets/customer/default/controls/Brightness4.svg';
import BrightnessFilled from './assets/customer/default/controls/BrightnessFilled.svg';
import Chapter from './assets/customer/default/controls/Chapter.svg';
import Chromecast from './assets/customer/default/controls/Chromecast.svg';
import ChromecastOff from './assets/customer/default/controls/ChromecastOff.svg';
import ChromecastOff1 from './assets/customer/default/controls/ChromecastOff1.svg';
import ChromecastOff2 from './assets/customer/default/controls/ChromecastOff2.svg';
import ChromecastOn from './assets/customer/default/controls/ChromecastOn.svg';
import ChromecastOn1 from './assets/customer/default/controls/ChromecastOn1.svg';
import ChromecastOn2 from './assets/customer/default/controls/ChromecastOn2.svg';
import ClosedCaption from './assets/customer/default/controls/ClosedCaption.svg';
import ClosedCaptionFilled from './assets/customer/default/controls/ClosedCaptionFilled.svg';
import Contact from './assets/customer/default/controls/Contact.svg';
import ErrorEmoji from './assets/customer/default/controls/ErrorEmoji.svg';
import FullscreenOff from './assets/customer/default/controls/FullscreenOff.svg';
import FullscreenOn from './assets/customer/default/controls/FullscreenOn.svg';
import Info from './assets/customer/default/controls/Info.svg';
import InfoFocused from './assets/customer/default/controls/InfoFocused.svg';
import Pause from './assets/customer/default/controls/Pause.svg';
import PictureInPicture from './assets/customer/default/controls/PictureInPicture.svg';
import Play from './assets/customer/default/controls/Play.svg';
import Playlist from './assets/customer/default/controls/Playlist.svg';
import PlaylistFocused from './assets/customer/default/controls/PlaylistFocused.svg';
import RelatedVideos from './assets/customer/default/controls/RelatedVideos.svg';
import Remote from './assets/customer/default/controls/Remote.svg';
import Replay from './assets/customer/default/controls/Replay.svg';
import SeekBackward from './assets/customer/default/controls/SeekBackward.svg';
import SeekBackwardFeedback from './assets/customer/default/controls/SeekBackwardFeedback.svg';
import SeekForward from './assets/customer/default/controls/SeekForward.svg';
import SeekForwardFeedback from './assets/customer/default/controls/SeekForwardFeedback.svg';
import Settings from './assets/customer/default/controls/Settings.svg';
import SettingsEco1 from './assets/customer/default/controls/SettingsEco1.svg';
import SettingsEco2 from './assets/customer/default/controls/SettingsEco2.svg';
import SettingsFocused from './assets/customer/default/controls/SettingsFocused.svg';
import Share from './assets/customer/default/controls/Share.svg';
import ShareFocused from './assets/customer/default/controls/ShareFocused.svg';
import SkipNext from './assets/customer/default/controls/SkipNext.svg';
import SkipNextFocused from './assets/customer/default/controls/SkipNextFocused.svg';
import SkipPrevious from './assets/customer/default/controls/SkipPrevious.svg';
import SkipPreviousFocused from './assets/customer/default/controls/SkipPreviousFocused.svg';
import Space from './assets/customer/default/controls/Space.svg';
import Speed from './assets/customer/default/controls/Speed.svg';
import SpeedFilled from './assets/customer/default/controls/SpeedFilled.svg';
import StartOver from './assets/customer/default/controls/StartOver.svg';
import SwitchAudioIcon from './assets/customer/default/controls/SwitchAudioIcon.svg';
import SwitchVideoIcon from './assets/customer/default/controls/SwitchVideoIcon.svg';
import Timer from './assets/customer/default/controls/Timer.svg';
import TimerFilled from './assets/customer/default/controls/TimerFilled.svg';
import Tracks from './assets/customer/default/controls/Tracks.svg';
import TracksFilled from './assets/customer/default/controls/TracksFilled.svg';
import Usabilla from './assets/customer/default/controls/Usabilla.svg';
import VOST from './assets/customer/default/controls/VOST.svg';
import Volume from './assets/customer/default/controls/Volume.svg';
import Volume1 from './assets/customer/default/controls/Volume1.svg';
import Volume2 from './assets/customer/default/controls/Volume2.svg';
import Volume3 from './assets/customer/default/controls/Volume3.svg';
import Volume4 from './assets/customer/default/controls/Volume4.svg';
import VolumeDown from './assets/customer/default/controls/VolumeDown.svg';
import VolumeFilled from './assets/customer/default/controls/VolumeFilled.svg';
import VolumeOff from './assets/customer/default/controls/VolumeOff.svg';
import VolumeUp from './assets/customer/default/controls/VolumeUp.svg';

export default {
  AirPlay,
  AirPlayOff,
  AirPlayOn,
  ArrowDown,
  ArrowLeftWithBase,
  ArrowUp,
  AudioDescription,
  BackSpace,
  BackToLive,
  BackToLiveHBBTV,
  Brightness,
  Brightness1,
  Brightness2,
  Brightness3,
  Brightness4,
  BrightnessFilled,
  Chapter,
  Chromecast,
  ChromecastOff,
  ChromecastOff1,
  ChromecastOff2,
  ChromecastOn,
  ChromecastOn1,
  ChromecastOn2,
  ClosedCaption,
  ClosedCaptionFilled,
  Contact,
  ErrorEmoji,
  FullscreenOff,
  FullscreenOn,
  Info,
  InfoFocused,
  Pause,
  PictureInPicture,
  Play,
  Playlist,
  PlaylistFocused,
  RelatedVideos,
  Remote,
  Replay,
  SeekBackward,
  SeekBackwardFeedback,
  SeekForward,
  SeekForwardFeedback,
  Settings,
  SettingsEco1,
  SettingsEco2,
  SettingsFocused,
  Share,
  ShareFocused,
  SkipNext,
  SkipNextFocused,
  SkipPrevious,
  SkipPreviousFocused,
  Space,
  Speed,
  SpeedFilled,
  StartOver,
  SwitchAudioIcon,
  SwitchVideoIcon,
  Timer,
  TimerFilled,
  Tracks,
  TracksFilled,
  Usabilla,
  VOST,
  Volume,
  Volume1,
  Volume2,
  Volume3,
  Volume4,
  VolumeDown,
  VolumeFilled,
  VolumeOff,
  VolumeUp,
};
